// ============================================
// AtWorkHealthBadge - Trạng thái kết nối Nedap AtWork
// ============================================
//
// GET /atwork/health/ (mục 3.7) — poll 30s. Payload: { enabled, status, data? }.
//   enabled=true & status='ok' → OK (xanh) · enabled=false/status='disabled' → Tắt (xám)
//   · lỗi request/khác → Lỗi (đỏ).

import { useI18n } from '../../../i18n';
import { useAtWorkHealth } from '../../../hooks';

type Tone = 'green' | 'amber' | 'red' | 'slate';

const TONE_CLASS: Record<Tone, string> = {
  green: 'bg-green-100 text-green-700',
  amber: 'bg-amber-100 text-amber-700',
  red: 'bg-red-100 text-red-700',
  slate: 'bg-slate-100 text-slate-600',
};

const DOT_CLASS: Record<Tone, string> = {
  green: 'bg-green-500',
  amber: 'bg-amber-500',
  red: 'bg-red-500',
  slate: 'bg-slate-400',
};

export function AtWorkHealthBadge() {
  const { t } = useI18n();
  const { data, isLoading, isError } = useAtWorkHealth();

  let tone: Tone = 'slate';
  let label = t('atworkHealthChecking');

  if (isLoading) {
    tone = 'slate';
    label = t('atworkHealthChecking');
  } else if (isError) {
    tone = 'red';
    label = t('atworkHealthUnreachable');
  } else if (data) {
    const status = (data.status ?? '').toLowerCase();
    if (data.enabled === false || status === 'disabled') {
      tone = 'slate';
      label = t('atworkHealthDisabled');
    } else if (data.enabled && status === 'ok') {
      tone = 'green';
      label = t('atworkHealthConnected');
    } else {
      tone = 'red';
      label = t('atworkHealthDown');
    }
  }

  return (
    <span
      title={data?.status ? `status: ${data.status}` : undefined}
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium ${TONE_CLASS[tone]}`}
    >
      <span
        className={`h-2 w-2 rounded-full ${DOT_CLASS[tone]} ${
          tone === 'green' ? 'animate-pulse' : ''
        }`}
      />
      {t('atworkNedapConnection')}: {label}
    </span>
  );
}
